import { z } from 'zod';

export const zodChildCompanyLetterInfoSchema = z.object({
  companyId: z.uuid(),
  companyName: z.string(),
  uploadedAt: z.iso.datetime({ offset: true }).nullable(),
});

export const zodSupplierLetterOverridesResponseSchema = z.object({
  childCompaniesWithLetter: z.array(zodChildCompanyLetterInfoSchema),
});
